import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  useReducer,
} from 'react';

import { IPayment } from '@/modules/payment/types';

import { Actions, subscriptionReducer } from './reducer';

export type InitialStateType = {
  planId: string;
  intervalType: IPayment.IIntervalTypes;
};

const initialState: InitialStateType = {
  planId: '',
  intervalType: 'year',
};

const SubscriptionContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null,
});

const SubscriptionProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(subscriptionReducer, initialState);

  return (
    <SubscriptionContext.Provider value={{ state, dispatch }}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export { SubscriptionContext, SubscriptionProvider };
